import(/* webpackMode: "eager" */ "/srv/apps/financecareers/releases/4ed5bda-202611041334/src/app/global-error.tsx");
